import axios from '@/libs/api.request'

export const uploadTableData = form => {
  return axios.request({
    url: 'device/upload',
    data: form,
    method: 'post'
  })
}

export const getVersionList = param => {
  return axios.request({
    url: 'device/select/' + param.pageNum + '/' + param.pageSize,
    params: param,
    method: 'get'
  })
}

export const getqueryuploadList = param => {
  return axios.request({
    url: '/device/query-upload-info',
    params: param,
    method: 'get'
  })
}

export const getdeviceversion = param => {
  return axios.request({
    url: '/device/get-version',
    params: param,
    method: 'get'
  })
}

export const getdevicemodelList = param => {
  return axios.request({
    url: 'device/get-device-model',
    params: param,
    method: 'get'
  })
}



export const deviceAlgorithmVersion = param => {
  return axios.request({
    url: '/device/algorithm-version',
    params: param,
    method: 'get'
  })
}




export const deviceAlgorithmList = param => {
  return axios.request({
    url: '/device/algorithm-list',
    params: param,
    method: 'get'
  })
}

export const removeVersion = param => {
  return axios.request({
    url: 'device/delete',
    params: param,
    method: 'get'
  })
}

export const editVersion = param => {
  return axios.request({
    url: 'device/update',
    data: param,
    method: 'post'
  })
}

export const uploadFtpInfo = param => {
  return axios.request({
    url: 'ftpInfo/insert',
    data: param,
    method: 'post'
  })
}

export const getFtpList = () => {
  return axios.request({
    // url: 'UtilERP/ftpInfo/select',
    url: 'ftpInfo/select',
    method: 'get'
  })
}

export const editFtpInfo = param => {
  return axios.request({
    url: 'ftpInfo/update',
    data: param,
    method: 'post'
  })
}

export const removeFtpInfo = param => {
  return axios.request({
    url: 'ftpInfo/delete',
    params: param,
    method: 'get'
  })
}

export const getTableData = () => {
  return axios.request({
    url: 'get_table_data',
    method: 'get'
  })
}

export const getDragList = () => {
  return axios.request({
    url: 'get_drag_list',
    method: 'get'
  })
}

export const errorReq = () => {
  return axios.request({
    url: 'error_url',
    method: 'post'
  })
}

// export const saveErrorLogger = info => {
//   return axios.request({
//     url: 'save_error_logger',
//     data: info,
//     method: 'post'
//   })
// }

/**
 * 升级包语言接口
 */
export const getLauage = () => {
  return axios.request({
    url: '/device/getLang',
    method: 'get'
  })
}
